<template>
  <v-dialog
    v-if="shiftId"
    v-model="dialog"
    :fullscreen="xs"
    size="x-large"
    max-width="900px"
  >
    <global-card
      :title="t('shift.details')"
      closable
      @close="close"
    >
      <shift-details
        :shift-id="shiftId"
        :with-breadcrumbs="false"
      />
      <template #actions>
        <v-btn
          :text="t('actions.close')"
          class="mr-4"
          color="dark-grey"
          @click="close"
        />
      </template>
    </global-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import ShiftDetails from '../ShiftDetails.vue';

const { xs } = useDisplay();
const { t } = useI18n();

const dialog = ref(false);
const shiftId = ref<number | null>(null);

function show(shiftID: number | undefined): void {
  shiftId.value = shiftID ?? null;
  dialog.value = true;
}

function close() {
  dialog.value = false;
}

defineExpose({ show });
</script>
